<template>
    <b-form-row>
        <b-modal v-model="showModal" size="xl" button-size="sm" ref="finder" hide-footer :id="this.id"
            :title="prefix + title">
            <EspecificacaoProdutoList :prefix="prefix + title" :produto="produto" :almoxarifado="almoxarifado"
                @onDblClickItem="rowSelect" />
        </b-modal>

        <lg-form-input-finder v-if="!isModal" :value="computedValue" @input="updateValue" fieldDescription="descricao"
            :label="label" invalidFeedback="Especificação do Produto deve ser informada!" description=""
            @handleClean="handleClean" :error="error" :cols="cols" :disabled="disabled">
            <template #prepend>
                <b-button :disabled="disabled" @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"

export default {
    components: { LgFormInputFinder, EspecificacaoProdutoList: () => import('@/modules/cadastros/especificacao-produto/EspecificacaoProdutoList.vue') },
    props: {
        isModal: {
            type: Boolean,
            default: false
        },
        almoxarifado: {
            type: Boolean,
            default: false,
        },
        produto: Object,
        disabled: {
            type: Boolean,
            default: false
        },

        id: String,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Especificação do Produto",
        },
        value: Object,
        cols: String,
        label: String,
        error: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            showModal: this.isModal ? true : false,

            internalValue: this.value || {},
        };
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
    },
    computed: {
        computedValue: {
            get() {
                return this.internalValue;
            },
            set(newValue) {
                this.internalValue = newValue;
            },
        },
    },
    methods: {
        show() {
            this.$bvModal.show(this.id);
        },
        updateValue(newValue) {
            this.computedValue = newValue;
            this.$emit("input", newValue);
        },
        handleClean() {
            this.computedValue = {};
            this.$emit("input", {});
            this.$bvModal.hide(this.id);

        },
        rowSelect(item) {
            this.computedValue = item;
            this.$emit("input", item);
            this.$bvModal.hide(this.id);
        },
    },
};
</script>
